import script from "./CentralAreaRemuneration.vue?vue&type=script&setup=true&lang=ts"
export * from "./CentralAreaRemuneration.vue?vue&type=script&setup=true&lang=ts"

import "./CentralAreaRemuneration.vue?vue&type=style&index=0&id=58811c18&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58811c18"]])

export default __exports__